import React from "react";
import { Icon } from "./UIElements/Icon";

const LocaleSelector = ({
  id,
  label,
  value,
  onChange,
  options,
  showLabel = true,
  showLeadingIcon = true,
  containerClassName = "",
  labelClassName = "",
  selectClassName = "",
}) => {
  return (
    <div
      className={`inline-flex items-center ${showLabel ? "gap-2" : ""} ${containerClassName}`}
    >
      <label
        htmlFor={id}
        className={`${showLabel ? `text-muted-foreground text-xs font-semibold tracking-wide ${labelClassName}` : "sr-only"}`}
      >
        {label}
      </label>

      <div className="relative">
        {showLeadingIcon && (
          <Icon
            name="Languages"
            className="pointer-events-none absolute top-1/2 left-2.5 h-3 w-3 -translate-y-1/2 text-cyan-300"
          />
        )}
        <select
          id={id}
          value={value}
          onChange={onChange}
          aria-label={label}
          className={`h-9 min-w-[124px] cursor-pointer appearance-none rounded-lg border border-white/15 bg-slate-950/80 py-1 pr-7 text-sm font-medium text-white shadow-none backdrop-blur-sm transition-colors outline-none focus:border-cyan-400/80 focus:ring-2 focus:ring-cyan-500/20 ${showLeadingIcon ? "pl-8" : "pl-3"} ${selectClassName}`}
        >
          {options.map((option) => (
            <option key={option.code} value={option.code}>
              {option.label}
            </option>
          ))}
        </select>
        <Icon
          name="ChevronDown"
          className="pointer-events-none absolute top-1/2 right-2 h-3.5 w-3.5 -translate-y-1/2 text-white/70"
        />
      </div>
    </div>
  );
};

export default LocaleSelector;
